import { render } from "./AddressBookView.vue?vue&type=template&id=76fb14f6&scoped=true"
import script from "./AddressBookView.vue?vue&type=script&lang=js"
export * from "./AddressBookView.vue?vue&type=script&lang=js"

import "./AddressBookView.vue?vue&type=style&index=0&id=76fb14f6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76fb14f6"]])

export default __exports__